import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'

import userBurgerIcon from '../../assets/imgs/icons/user-burger-icon.svg'

import './style.scss'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { useState } from 'react'
import UserPopUp from '../userPopUp/UserPopUp'

function UserIndicator() {
	const isLoggedIn = useAppSelector(state => state.user.isLoggedIn)
	const useMobileLayout = useAppSelector(state => state.resize.useMobileLayout)
	const [showUserPopUp, setShowUserPopUp] = useState<boolean>(false)

	return (
		<div className="user-indicator-wrap">
			{!userStateData.isAnInstructor() && !useMobileLayout && (
				<button
					className='user-cta-text-button'
					onClick={() => {
						window.location.replace(PAGE_URLS.SIGN_UP_INSTRUCTOR)
					}}
				>Become an Instructor</button>
			)}
			{isLoggedIn ? (
				<>
					<img 
						src={userBurgerIcon}
						className="user-burger-icon"
						alt="Burger Icon" 
					/>
					<img 
						src={userStateData.getUserIconUrl()}
						className="user-indicator-icon"
						alt="User Icon" 
						onClick={() => {
							setShowUserPopUp(!showUserPopUp)
						}}
					/>
				</>
			) : (
				<a 
					className='user-sign-up-cta'
					href={PAGE_URLS.LOG_IN}
				>Log In</a>
			)}
			{showUserPopUp && <UserPopUp />}
		</div>
	)
}

export default UserIndicator
